<template>
  <section
    class="tutorial"
    :class="isMobile() ? 'mobile-overlay' : ''"
  >
    <tutorial-tasks
      :tasks="tasks"
    />
    <tutorial-overlay
      v-if="
        tutorialState.anne.showAnne || tutorialState.tutorialMessage.showMessage
      "
      style="pointer-events: auto"
      @click.prevent=""
      @mousedown.prevent=""
      @mouseup.prevent=""
      @touchstart.prevent=""
      @touchend.prevent=""
    />
    <tutorial-anne
      v-if="tutorialState.anne.showAnne"
      :is-right="tutorialState.anne.isRight"
      :instructor-name="tutorialState.anne.instructorName"
    />
    <tutorial-message-box
      v-if="tutorialState.tutorialMessage.showMessage"
      :key="tutorialState.tutorialMessage.message"
      :type-write="tutorialCoreState.typeWriter"
      :class="{ offsetBot: tutorialState.tutorialMessage.offset }"
      :header-text="$t(tutorialState.anne.instructorNameText)"
      :text="$t(tutorialState.tutorialMessage.message)"
      :color="tutorialState.tutorialMessage.color"
      :button-yellow-text="tutorialState.tutorialMessage.yellowText"
      :force-hide-white-text="tutorialState.tutorialMessage.yellowTextSpecial"
      @show-full-text="setTypewriteToInactive"
    />
    <tutorial-hand-settings
      v-if="tutorialState.mobile"
      style="pointer-events: auto"
      img-url="https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/100m/ui/tutorial/mobile_100m.jpg"
      @mousedown.stop=""
      @mouseup.stop=""
      @touchstart.stop=""
      @touchend.stop=""
      @click-continue="continueTask"
    />
    <instruction-box
      v-if="tutorialState.showInstructionBox"
      style="bottom: 20%"
      :text-for-parse="$t(tutorialState.instructionBoxText)"
      :icon="tutorialState.instructionBoxIcon"
    />
    <tutorial-bars
      v-if="tutorialState.showSpeedBar"
      class="speed-bar"
    />
    <info-component
      v-if="tutorialState.showBarStart"
      glow
    />
    <tutorial-finger v-if="tutorialState.showFinger" />
  </section>
</template>

<script lang="ts">
import {
  WindowAspect,
  TutorialAnne,
  TutorialMessageBox,
  TutorialTasks,
  TutorialOverlay,
  TutorialHandSettings,
  InstructionBox,
  tutorialCoreState,
  gameSettingsState
} from '@powerplay/core-minigames-ui-ssm'
import {
  settings,
  tutorialManager
} from '@powerplay/core-minigames'
import type { TutorialObjective } from '@powerplay/core-minigames'
import TutorialBars from '@/components/Tutorial/TutorialBars.vue'
import { pathAssets } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import InfoComponent from '../InfoComponent.vue'
import { tutorialState } from '@/stores'
import TutorialFinger from '../TutorialFinger.vue'

type TaskType = {
  color: string
  text: string
}

export default defineComponent({
  name: 'TutorialLogicComponent',
  components: {
    TutorialAnne,
    TutorialMessageBox,
    TutorialTasks,
    TutorialOverlay,
    TutorialHandSettings,
    TutorialBars,
    InstructionBox,
    InfoComponent,
    TutorialFinger
  },
  mixins: [WindowAspect],
  data() {

    return {
      tasks: [] as TaskType[],
      pathAssets,
      tutorialState: tutorialState(),
      tutorialCoreState: tutorialCoreState(),
    }

  },
  computed: {
    basicStyle() {

      return {
        'align-items': 'flex-end',
        width: '290px',
        height: '200px',
        padding: '20px'
      }

    }
  },

  watch: {
    tutorialState: {
      immediate: true,
      deep: true,
      handler() {

        this.updateTasks()

      }
    }
  },
  methods: {
    setTypewriteToInactive() {

      tutorialCoreState().typeWriter = false
      tutorialManager.setTypeWriting(false)

    },
    continueTask() {

      this.setThings()
      settings.saveValues()
      window.dispatchEvent(new Event('mousedown'))

    },
    setThings(): void {

      settings.update('quality', gameSettingsState().graphicsSettings)
      settings.update('sounds', gameSettingsState().volume ? 1 : 0)
      settings.update('qualityAuto', gameSettingsState().graphicsAuto ? 1 : 0)
      settings.update('isLeft', gameSettingsState().isLeft ? 1 : 0)

    },
    updateTasks() {

      this.tasks = this.tutorialState.objectives.map((objective: TutorialObjective) => {

        let color = 'blue'
        if (objective.passed) color = 'green'
        if (objective.failed) color = 'red'
        return {
          color,
          text: this.$t(objective.name)
        }

      })

    }
  }
})
</script>

<style lang="less">
.tutorial {

  .offsetBot {
    top: 5%;
  }
    &.mobile-overlay {
      .tutorial-anne, .tutorial-mobil, .tutorial-hand-bottom {
          position: fixed;
      }
      .offsetBot {
        top: 10%;
      }
    }


  .tutorial-tasks {
    position: absolute;
    left: 1%;
    top: 14%;
  }
  .speed-bar {
    position: absolute;
    top: 60%;
    left: 55%;
    transform: translate(-50%, -50%);
  }
}
.mobiler {
    height: 100%;

    .buttons {
        position: relative;
        width: 100%;
        height: 100%;

        .button-group {
            position: absolute;
            bottom: 130px;
            left: 130px;
            right: 130px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &.reverse {
                flex-direction: row-reverse;
            }
        }
    }
}
</style>
